import { useAuthStore } from '../store/auth'
import { useDirectory } from '../store/directory'
import { useFavorites } from '../store/favorites'
import { useUserStore } from '../store/user'

export const handleLogout = () => {
  //useConfigStore.getState().logout()
  useUserStore.getState().logout()
  useAuthStore.getState().logout()
  useFavorites.getState().logout()
  useDirectory.getState().logout()
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return String(parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i])
}
